module.exports = __webpack_public_path__ + "static/media/star_icon.ce53db16.svg";